import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { api, unwrap } from "@/lib/api/client";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { MachinePage } from "@/features/machine/machine-page";
import { Skeleton } from "@/components/skeleton";
import { optionalString } from "@/lib/search";
import { uploadSearch, type UploadSearch } from "@/lib/upload-route";

export interface MachineSearch extends UploadSearch {
  /** Assembly id; an unknown id falls back to "All" (the page removes the param). */
  assembly?: string;
}

export const Route = createFileRoute("/machines/$key")({
  validateSearch: (raw: Record<string, unknown>): MachineSearch => ({
    assembly: optionalString(raw.assembly),
    ...uploadSearch(raw),
  }),
  component: MachineRoute,
});

function MachineRoute() {
  const { key } = Route.useParams();
  const { assembly } = Route.useSearch();
  const navigate = useNavigate();
  const resolved = useQuery({
    queryKey: ["catalog", "resolve", key],
    queryFn: () =>
      unwrap(api.GET("/api/v1/instruments/resolve/{key}", { params: { path: { key } } })),
  });
  useEffect(() => {
    if (resolved.data?.instrument_id)
      void navigate({
        to: "/instruments/$id",
        params: { id: resolved.data.instrument_id },
        replace: true,
      });
  }, [resolved.data, navigate]);
  if (resolved.isPending || resolved.data?.instrument_id) return <Skeleton className="m-8 h-64" />;
  return <MachinePage machineKey={key} assembly={assembly} />;
}
